export default __webpack_public_path__ + "static/media/building-icon-light.9acc2a0a.svg";